import { doc, getDoc, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { firestore } from "../firebase";
import {
  mapDocToPublicListing,
  PublicListing,
  PublicListingCollection,
} from "../types/PublicListing";

export async function getPublicListing(
  projectId: string,
): Promise<PublicListing | null> {
  const docRef = doc(firestore, PublicListingCollection, projectId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return mapDocToPublicListing(docSnap.id, docSnap.data());
  }
  return null;
}

export async function createPublicListing(
  projectId: string,
  data: Omit<PublicListing, "id" | "createdAt" | "updatedAt">,
): Promise<PublicListing> {
  const now = Timestamp.now();
  const listingData = {
    ...data,
    createdAt: now,
    updatedAt: now,
  };
  const docRef = doc(firestore, PublicListingCollection, projectId);
  await setDoc(docRef, listingData);
  return mapDocToPublicListing(projectId, listingData);
}

export async function updatePublicListing(
  projectId: string,
  updates: Partial<Omit<PublicListing, "id" | "createdAt">>,
): Promise<void> {
  const docRef = doc(firestore, PublicListingCollection, projectId);
  await updateDoc(docRef, { ...updates, updatedAt: Timestamp.now() });
}
